import Constants from "../utils/consts";

export const addPresenzaCrossCorso = async (
  username,
  token,
  idLezione,
  idStudente,
  presenza = 1,
  ore = null
) => {
  try {
    console.log(
      `[addPresenzaCrossCorso] Recupero cross-corso per studente ${idStudente}, lezione ${idLezione}`
    );

    const formData = new FormData();
    formData.append("uname", username);
    formData.append("token", token);
    formData.append("id_studente", idStudente);
    formData.append("id_lezione", idLezione);

    if (ore) {
      formData.append("ore_recuperate", ore);
    }
    formData.append("note_recupero", "Recupero cross-corso tramite sistema");

    console.log(
      `[addPresenzaCrossCorso] Chiamando recuperaAssenzaCrossCorso.php...`
    );

    const response = await fetch(
      Constants.mainUrl + "recuperaAssenzaCrossCorso.php",
      {
        method: "POST",
        body: formData,
      }
    );

    const result = await response.json();
    console.log(
      `[addPresenzaCrossCorso] Risposta API recuperaAssenzaCrossCorso:`,
      result
    );

    return result;
  } catch (error) {
    console.error("Errore addPresenzaCrossCorso:", error);
    return { result: "KO", error: error.message };
  }
};

export const getAssenzeCrossCorso = async (username, token, idStudente) => {
  try {
    console.log(
      `[getAssenzeCrossCorso] Caricamento stati assenze cross-corso per studente ${idStudente}`
    );

    const formData = new FormData();
    formData.append("uname", username);
    formData.append("token", token);
    formData.append("id_studente", idStudente);

    const response = await fetch(
      Constants.mainUrl + "getAssenzeCrossCorso.php",
      {
        method: "POST",
        body: formData,
      }
    );

    const data = await response.json();
    console.log(
      `[getAssenzeCrossCorso] Risposta API getAssenzeCrossCorso:`,
      data
    );

    return data;
  } catch (error) {
    console.error("Errore getAssenzeCrossCorso:", error);
    return { result: "KO", error: error.message };
  }
};
